<template>
	<div v-if="!getLoadingModule" class="main module-dashboard dashboard" style="height: auto;">

		<div v-if="clientFFLNumbers.length > 0" style="margin: 0 0 1em 0;">
			<label class="full">FFL Number</label>
			<select v-model="filters.client_ffl_number_id" style="width: 21em;" @change="fetchStats()">
				<option v-for="(clientFFLNumber, index) in clientFFLNumbers" :key="index" :value="clientFFLNumber.client_ffl_number_id">{{ clientFFLNumber.ffl_number }}</option>
			</select>
			<div class="divider"></div>
		</div>

		<div class="dashboard-tiles dashboard-tiles-quarter">
			<div class="dashboard-tile compliance" v-for="(logbook, index) in getLogbooks" :key="index">
				<div class="dashboard-tile-title">{{ logbook.description }}</div>
				<router-link class="pointer" :to="'/logbooks/list?on_hand=1&log_books=' + logbook.ffl_log_book_id + '&page=1'" tag="div">
					<span class="dashboard-tile-stat">{{ logbook.on_hand }}</span><span class="dashboard-tile-caption">on hand</span>
				</router-link>
				<router-link class="dashboard-link" :class="{ onhand: logbook.on_hand > 0, disabled: logbook.on_hand == 0 }" :to="{ path: '/logbooks/list', query: { on_hand: 1, log_books: logbook.ffl_log_book_id } }" tag="button">List</router-link>
				<router-link class="onhand dashboard-link" :to="{ path: '/logbooks/receive', query: { log_book: logbook.ffl_log_book_id } }" tag="button">Receive</router-link>
			</div>
		</div>

		<div class="dashboard-tiles dashboard-tiles-half">
			<div class="dashboard-tile">
				<div class="dashboard-tile-title">Recent Acquisitions</div>
				<table class="dashboard-tile-list" cellpadding="0" cellspacing="0">
					<tr>
						<th>Date</th>
						<th>From</th>
						<th>Item</th>
						<th>Serial</th>
					</tr>
					<router-link class="list clickable-list-item" tag="tr" :to="'/logbooks/list?id=' + acquisition.ffl_log_book_entry_id" v-for="(acquisition, index) in getRecentAcquisitions" :key="index">
						<td>{{ acquisition.receipt_date }}</td>
						<td>{{ acquisition.originator_full_name }}</td>
						<td>{{ acquisition.item }}</td>
						<td>{{ acquisition.serial_number }}</td>
					</router-link>
				</table>
			</div>

			<div class="dashboard-tile">
				<div class="dashboard-tile-title">Recent Dispositions</div>
				<table class="dashboard-tile-list" cellpadding="0" cellspacing="0">
					<tr>
						<th>Date</th>
						<th>To</th>
						<th>Item</th>
						<th>Serial</th>
					</tr>
					<router-link class="list clickable-list-item" tag="tr" :to="'/logbooks/list?id=' + disposition.ffl_log_book_entry_id" v-for="(disposition, index) in getRecentDispositions" :key="index">
						<td>{{ disposition.disposal_date }}</td>
						<td>{{ disposition.disposal_full_name }}</td>
						<td>{{ disposition.item }}</td>
						<td>{{ disposition.serial_number }}</td>
					</router-link>
				</table>
			</div>
		</div>

		<div class="dashboard-tiles dashboard-tiles-third">
			<div class="dashboard-tile">
				<div class="dashboard-tile-title">Multiple Firearms Sales Alerts</div>
				<div class="dashboard-tile-empty-list" v-if="getMultiplePurchases.length == 0">No Results</div>
				<table class="dashboard-tile-list" v-else cellpadding="0" cellspacing="0">
					<tr>
						<th>Dates</th>
						<th>Items</th>
						<th>Disposed To</th>
						<th>Form</th>
					</tr>
					<router-link v-for="(multiple_purchase, index) in getMultiplePurchases" class="list clickable-list-item" tag="tr" :to="'/logbooks/3310?ffl_multiple_purchase_id=' + multiple_purchase.ffl_multiple_purchase_id" :key="index">
						<td>{{ $moment(multiple_purchase.start_date).format('MM/DD') }} - {{ $moment(multiple_purchase.end_date).format('MM/DD') }}</td>
						<td>{{ multiple_purchase.ffl_log_book_entry_ids.length }}</td>
						<td>{{ multiple_purchase.full_name }}</td>
						<td>{{ multiple_purchase.form_version }}</td>
					</router-link>
				</table>
			</div>
			<div class="dashboard-tile">
				<div class="dashboard-tile-title">4473 Forms Awaiting Action</div>
				<div class="dashboard-tile-empty-list" v-if="getPending4473.length == 0">No Results</div>
				<table class="dashboard-tile-list" v-else cellpadding="0" cellspacing="0">
					<tr>
						<th>Date</th>
						<th>Name</th>
					</tr>
					<router-link class="list clickable-list-item" tag="tr" :to="'/logbooks/4473/' + (pending.version > 1 ? '' : 'legacy/') + pending.ffl_log_book_form_id" v-for="(pending, index) in getPending4473" :key="index">
						<td>{{ pending.date_created }}</td>
						<td v-if="pending.version > 1">{{ pending.form_data.section_b.first_name }} {{ pending.form_data.section_b.last_name }}</td>
						<td v-else>{{ pending.form_data.first_name }} {{ pending.form_data.last_name }}</td>
					</router-link>
				</table>
			</div>

			<div class="dashboard-tile">
				<div class="dashboard-tile-title">Recent Sales Pending Disposition</div>
				<div class="dashboard-tile-empty-list" v-if="getPartialDispositions.length == 0">No Results</div>
				<table class="dashboard-tile-list" v-else cellpadding="0" cellspacing="0">
					<tr>
						<th>Date</th>
						<th>Name</th>
					</tr>
					<router-link class="list clickable-list-item" tag="tr" :to="'/logbooks/list?id=' + partial.ffl_log_book_entry_id" v-for="(partial, index) in getPartialDispositions" :key="index">
						<td>{{ partial.disposal_date }}</td>
						<td>{{ partial.disposal_full_name }}</td>
					</router-link>
				</table>
			</div>

		</div>

		<div class="modal" v-if="exportRequired">
			<div class="inner">
				<h2>Export</h2>
				<div class="content">
					<p style="margin: 2em;">It's been 24 hours or more since your last full logbook export.</p>
					<div v-if="modalMessage" class="empty" v-html="modalMessage"></div>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="exportRequired = false">Cancel</div>
					<div class="button action spaced" @click="doFullExport()">Export Now</div>
				</div>
			</div>
		</div>

		<iframe id="download" src="" style="display: none;"></iframe>

	</div>
    <loading class="full-page" v-else></loading>

</template>

<script>
// Vue.component('list-component', ListComponent)
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
	name: 'logbooks-dashboard',
	data() {
		return {
			exportRequired: false,
			modalMessage: '',
			clientFFLNumbers: [],
			filters: {
				client_ffl_number_id: ''
			}
		}
	},
	created() {
		this.getExportRequired()
	},
    mounted() {
        this.fetchStats()
    },
	computed: {
		// will get data from logbooks/store.js
        ...mapGetters('logbooks', [
            'getLoadingModule',
            'getLoadingModuleArray',
            'getLogbooks',
            'getTotals',
            'getRecentAcquisitions',
            'getRecentDispositions',
            'getPartialDispositions',
            'getMultiplePurchases',
            'getPending4473'
        ]),
		today() {
			return this.$moment()
		},
		yearStartDate() {
			return this.today.clone().startOf('year')
		}
	},
	methods: {
        ...mapActions('logbooks', [
            'updateLoadingModule',
            'updateProperty',
            'updateState'
        ]),
        fetchStats() {
            if (this.getLoadingModuleArray.indexOf('getDashboardStats') == -1) {
                this.updateLoadingModule({ value: 'getDashboardStats' })
                this.apiCall({ destination: 'get_logbook_dashboard_stats', data: { include_stats: 'partial_dispositions', client_ffl_number_id: this.filters.client_ffl_number_id } }).then(obj => {
                    this.updateLoadingModule({ value: 'getDashboardStats', remove: true })
                    if (obj.status == 'success') {
						if (obj.client_ffl_numbers) {
							this.clientFFLNumbers = obj.client_ffl_numbers
							if (this.clientFFLNumbers.length > 0 && !this.filters.client_ffl_number_id) {
								this.filters.client_ffl_number_id = this.clientFFLNumbers[0].client_ffl_number_id
							}
						}
						this.updateProperty({ property: 'logbooks', value: obj.logbooks })
                        this.updateState(obj)
                        this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: { disposable: 1 } }).then((obj) => {
                            if (obj.status == 'success') {
                                this.updateProperty({ property: 'pending_4473', value: obj.log_book_forms })
                            }
                        }).catch((err) => {
                            this.updateLoadingModule({ value: 'getDashboardStats', remove: true })
                            console.log(err)
                        })
                    }
                }).catch(err => {
                    this.updateLoadingModule({ value: 'getDashboardStats', remove: true })
                    console.log(err)
                })
            }
        },
		getExportRequired() {
			if (this.getUser.user_type_code == 'AUDITOR') { return }
			this.apiCall({ destination: 'get_logbooks_export_required' }).then(obj => {
				this.exportRequired = obj.export_required
			}).catch(err => {
				console.log(err)
			})
		},
		doFullExport() {
			// get_list_ffl_log_book_entries with export: 1
			this.modalMessage = 'Generating export file...'
			this.apiCall({ destination: 'get_list_ffl_log_book_entries', data: { export: 1, record_export_log: 1 } }).then(obj => {
				// set hidden iframe src to the returned download_url
				document.getElementById("download").src = obj.download_url
				this.modalMessage = obj.paging.total_items + ' items exported to file<br>' + obj.file_name
				var timer = setTimeout((function() {
					this.modalMessage = ''
					this.exportRequired = false
				}.bind(this)),3000)
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		}
	}
}
</script>
<style lang="scss" scoped>
</style>
